<template>
  <InputComponent
    v-bind="$attrs"
    class="field-combine-selector"
    :style="`--field-combine-selector-items-count:${itemsComp.length}`"
  >
    <template v-for="(category, categoryIndex) in itemsComp">
      <component
        class="field-combine-selector__category"
        v-bind="category"
        :is="category.component"
        :value="category.value"
        @input="$ev => setValue($ev, category, categoryIndex)"
        :disabled="category.disabled"
        :disable-placeholder="false"
      >
      </component>
    </template>

    <InputComponent
      v-if="!hideResult"
      class="field-combine-selector__result"
      :value="comp"
      :label="$t('result')"
      :disabled="true"
    >
    </InputComponent>
  </InputComponent>
</template>

<script>
import { InputComponent } from 'vue-elder-input'
import SelectModal from './SelectModal.vue'
import Select from './Select.vue'
import { ValueComp, CurlyTemplateReplacer } from '../utils'

import Icon from '@kvass/vue2-icon'

export default {
  props: {
    value: [String, Array],
    items: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: Array,
      default: () => [],
    },
    seperator: {
      type: String,
      default: '-',
    },
    hideResult: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required: [],
      usedCategories: [],
    }
  },
  computed: {
    comp: ValueComp(),
    itemsComp: {
      get: function () {
        return this.categories.map((c, index) => {
          let items = [...(this.items.filter(i => i.category === c.key) || [])]
          items = items.some(i => i.url)
            ? () => this.getItems(this.items.filter(i => i.category === c.key))
            : items.map(i => ({
                ...i,
                value: this.getItemValue(i),
              }))

          let allValues = (this.comp || '').split(this.seperator) || []

          let value =
            items instanceof Array
              ? allValues.find(i => items.some(p => this.getItemKey(p) === i))
              : allValues[index]

          const fieldIsDisabled = this.isDisabled(c.disabledIf)
          const hasRequired = this.categories.find(i => i.key === c.requiredIf)

          return {
            ...c,
            items,
            disabled: Boolean(fieldIsDisabled && this.comp),
            required: Boolean(this.comp && hasRequired && !fieldIsDisabled),
            value,
            component:
              typeof items === 'string' || typeof items === 'function' ? SelectModal : Select,
          }
        })
      },
      set: function (value) {
        let result = []
        value.forEach(i => {
          if (!i.value) return
          result.push(i.value)
        })

        //emit value or combined value
        return (this.comp = result.join(this.seperator))
      },
    },
  },

  methods: {
    setUseSate(value, key) {
      const usedCategoryIndex = this.usedCategories.indexOf(key)

      if (usedCategoryIndex > -1 && !value) {
        this.usedCategories.splice(usedCategoryIndex, 1)
      } else if (value) {
        this.usedCategories = [...new Set([...this.usedCategories, key])]
      }
    },
    hasRequired(item, category) {
      if (!item.requiredIf) return false
      return item.requiredIf === category
    },
    getItemValue(item) {
      return item.value || item.title
    },
    getItemKey(item) {
      return item.id || item.title
    },
    async getItems(items) {
      return await Promise.all(
        items.map(i => {
          if (i.url) {
            let rawUrl = i.url.startsWith('http') ? i.url : `${location.origin}${i.url}`

            let url = new URL(CurlyTemplateReplacer(rawUrl, this.$attrs['schema-data'] || {}))

            return fetch(url.toString()).then(res => res.json())
          }
          return i
        }),
      ).then(res => res.flat())
    },

    setValue(val, category, index) {
      this.setUseSate(val, category.key)

      this.itemsComp = this.itemsComp.map(item => {
        return {
          ...item,
          value: item.key === category.key ? val : item.value,
        }
      })
    },
    isDisabled(disabledIf) {
      //disabledIf is a reference another item
      if (!disabledIf) return

      //disabledIf can be multiple
      const disabledIfValue = disabledIf.includes(':') ? disabledIf.split(':') : [disabledIf]

      return this.usedCategories.some(c => disabledIfValue.includes(c))
    },
  },
  mounted() {
    this.itemsComp.forEach(i => this.setUseSate(i.value, i.key))
  },

  components: {
    InputComponent,
    Icon,
    SelectModal,
  },
}
</script>

<style lang="scss">
.field-combine-selector {
  & > .elder-input__wrapper > .elder-input__field {
    border: none;
    padding: 1rem;
    background-color: #f7f7f7;

    & > .elder-input__value {
      display: grid;
      grid-template-columns: repeat(var(--field-combine-selector-items-count), 1fr);
      gap: 1rem;
    }
  }

  .elder-input__wrapper {
    flex-grow: 0;
  }

  &__result {
    grid-column-end: span var(--field-combine-selector-items-count);

    .elder-input__field {
      font-weight: bold;
      &--disabled:before {
        opacity: 0.2;
        --vue-elder-input-color: hsl(var(--secondary-h), var(--secondary-s), 92%);
      }
    }
  }
}
</style>
